import { FC } from 'react';

import { Box, Paper } from '@mui/material';
import { IOnePageStyles, ONE_PAGE_STYLE_OPTIONS } from 'layouts/OnePagePreviewLayout';

import { ReactComponent as OnePageProjectCardIcon } from 'assets/icons/projectCardSvgs/OnePageProjectCardIcon.svg';
import OnePageFirstStyleBackground from 'assets/images/firstStyleWorkspace.png';
import OnePageSecondStyleBackground from 'assets/images/secondStyleWorkspace.png';
import OnePageThirdStyleBackground from 'assets/images/thirdStyleWorkspace.png';

import { IBusinessPlanEntity } from 'interfaces/businessPlan';

import { CardLowerSection } from '../CardLowerSection/CardLowerSection';

import styles from './OnePageCard.module.scss';

const getOnePagePreviewPic = (onePageTemplateStyle: IOnePageStyles) => {
  const onePageTemplatesMap = new Map([
    [ONE_PAGE_STYLE_OPTIONS.FIRST_STYLE, OnePageFirstStyleBackground],
    [ONE_PAGE_STYLE_OPTIONS.SECOND_STYLE, OnePageSecondStyleBackground],
    [ONE_PAGE_STYLE_OPTIONS.THIRD_STYLE, OnePageThirdStyleBackground],
  ]);

  return onePageTemplatesMap.get(onePageTemplateStyle) ?? OnePageFirstStyleBackground;
};

export const OnePageCard: FC<IBusinessPlanEntity> = (props) => {
  const { onePageTemplateStyle } = JSON.parse(String(props.metadata)) as IBusinessPlanEntity['metadata'];
  const imageSrc = getOnePagePreviewPic(onePageTemplateStyle);

  return (
    <Paper elevation={0} className={styles.wrapper}>
      <OnePageProjectCardIcon className={styles.iconStyles} />
      <Box className={styles.upperCard}>
        <img src={imageSrc} className={styles.backCard} alt="One page document style" />
      </Box>
      <CardLowerSection {...props} />
    </Paper>
  );
};
